import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, ProjectType2, TeamCountDto } from '../../../../../shared/service-proxies/service-proxies';
@Component({
    standalone: false,
    selector: 'app-teamdashboard-card-section',
    templateUrl: './teamdashboard-card-section.component.html',
    styleUrls: ['./teamdashboard-card-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamdashboardCardSectionComponent extends AppComponentBase implements OnInit {
    userTimeData = new TeamCountDto();
    isLoaded = false;
    isEmpty = true;
    istrueValue: boolean;
    absentEmployee: number;
    max: number = 100;
    stroke: number = 5;
    radius: number = 60;
    semicircle: boolean = false;
    rounded: boolean = false;
    responsive: boolean = false;
    clockwise: boolean = true;
    color: string = '#9B0B53'; //'#45ccce';
    background: string = '#eaeaea';
    duration: number = 800;
    animation: string = 'easeOutCubic';
    animationDelay: number = 0;
    gradient: boolean = false;
    realCurrent: number = 0;
    absentEmployees: any;
    lateEmployees: any;
    arrivedEmployees;
    getOverlayStyle() {
        const isSemi = this.semicircle;
        const transform = (isSemi ? '' : 'translateY(-50%) ') + 'translateX(-50%)';
        return {
            top: isSemi ? 'auto' : '52%',
            bottom: isSemi ? '5%' : 'auto',
            left: '52%',
            transform,
            'font-size': this.radius / 3.5 + 'px',
        };
    }
    constructor(private _AllDashboardServiceProxy: AllDashboardServiceProxy, injector: Injector) { super(injector); }
    leavesCards = [
        { id: 1, name: 'TotalMembers', price: '150', icon: 'assets/common/images/Activities/TeamDashboard_TotalMembers.png', class: 'text-color font-weight-bolder' },
        { id: 2, name: 'TotalProjects', price: '54', icon: 'assets/common/images/Activities/TotalProjects.png', class: 'text-color font-weight-bolder' },
        { id: 3, name: 'OngoingProjects', price: '12', icon: 'assets/common/images/Activities/PendingProjects.svg', class: 'text-color font-weight-bolder' },
        { id: 4, name: 'CompletedProjects', price: '42', icon: 'assets/common/images/Activities/CompletedProjects.png', class: 'text-color font-weight-bolder' },
        { id: 5, name: 'LeaveRequest', price: '09', icon: 'assets/common/images/Activities/TeamDashboard_TotalLeaveRequested.png', class: 'text-color font-weight-bolder' },
        { id: 6, name: 'AbsentEmployees', price: '1', icon: 'assets/common/images/Activities/AbsentEmployee.png', class: 'text-color font-weight-bolder' },
        { id: 7, name: 'LateEmployees', price: '8', icon: 'assets/common/images/Activities/LateEmployee.png', class: 'text-color font-weight-bolder' },
        { id: 8, name: 'ArrivedEmployees', price: '80', icon: 'assets/common/images/Activities/TeamDashboard_ArrivedEmp.png', class: 'text-color font-weight-bolder' }
    ];
    ngOnInit(): void {
        this.getUserdetails();
    }
    getUserdetails() {
        this.istrueValue = this.isGranted('Pages.ShowManager.Dashboard');
        this._AllDashboardServiceProxy.getAllTeamCount(ProjectType2.AllProjects, this.istrueValue).subscribe(result => {
            this.userTimeData = result;
            this.absentEmployee = result.totalMember - result.arrivedEmployee;
            this.isLoaded = true;
            this.isEmpty = false;
            // Calculate absentEmployees percentage
            this.absentEmployees = (100 * this.absentEmployee) / this.userTimeData.totalMember;
            if (isNaN(this.absentEmployees)) {
                this.absentEmployees = 0;
            }
            else {
                this.absentEmployees = Math.round(this.absentEmployees);
            }
            // Calculate lateEmployees percentage
            this.lateEmployees = (100 * this.userTimeData.lateEmployee) / this.userTimeData.totalMember;
            if (isNaN(this.lateEmployees)) {
                this.lateEmployees = 0;
            }
            else {
                this.lateEmployees = Math.round(this.lateEmployees);
            }
            // Calculate arrivedEmployees percentage
            this.arrivedEmployees = (100 * this.userTimeData.arrivedEmployee) / this.userTimeData.totalMember;
            if (isNaN(this.arrivedEmployees)) {
                this.arrivedEmployees = 0;
            }
            else {
                this.arrivedEmployees = Math.round(this.arrivedEmployees);
            }
            this.markForCheck();
        });
    }
}
